import { browser } from '$app/environment';

export const runKlaviyo = () => {
	if (!browser) return;

	// Inject Klaviyo script once using the environment company id
	if (!document.querySelector('script[data-klaviyo]')) {
		const script = document.createElement('script');
		script.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${import.meta.env.VITE_PUBLIC_KLAVIYO_KEY}`;
		script.async = true;
		script.defer = true;
		script.setAttribute('data-klaviyo', 'true');
		document.body.appendChild(script);
	}

	!(function () {
		if (!window.klaviyo) {
			window._klOnsite = window._klOnsite || [];
			try {
				window.klaviyo = new Proxy(
					{},
					{
						get: function (n, i) {
							return 'push' === i
								? function () {
										var n;
										(n = window._klOnsite).push.apply(n, arguments);
									}
								: function () {
										for (var n = arguments.length, o = new Array(n), w = 0; w < n; w++)
											o[w] = arguments[w];
										var t = 'function' == typeof o[o.length - 1] ? o.pop() : void 0,
											e = new Promise(function (n) {
												window._klOnsite.push(
													[i].concat(o, [
														function (i) {
															(t && t(i), n(i));
														}
													])
												);
											});
										return e;
									};
						}
					}
				);
			} catch (n) {
				((window.klaviyo = window.klaviyo || []),
					(window.klaviyo.push = function () {
						var n;
						(n = window._klOnsite).push.apply(n, arguments);
					}));
			}
		}
	})();
};
